'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { useContext } from 'react';
import { attachSubComponents, getChildByType, InternalProvider, isComponentType, usePropDeprecation } from '../../util';
import { BodyContainer, Container, Eyebrow } from './elements';
import { SimpleBlockContext } from './SimpleBlockContext';
import { Image } from './Image';
import { Tag } from './Tag';
import { Heading } from './Heading';
import { ImageTag } from './ImageTag';
import { ButtonGroup } from './SimpleBlockButtonGroup';
import { ActionGroup } from './SimpleBlockActionGroup';
import { SimpleCardContext } from '../SimpleCard/SimpleCardContext';
export const SimpleBlockComponents = {
  ActionGroup,
  /** @deprecated */
  ButtonGroup,
  Eyebrow,
  Heading,
  Image,
  ImageTag,
  Tag
};
export const SimpleBlock = attachSubComponents('SimpleBlock', /*#__PURE__*/React.forwardRef(({
  children,
  size = 'md',
  contentHeight,
  imagePosition,
  alignment = 'left',
  ...rest
}, fRef) => {
  const blockImage = getChildByType(children, Image);
  children = React.Children.toArray(children).filter(child => !isComponentType(child, Image));
  const simpleCardContext = useContext(SimpleCardContext);
  imagePosition ??= (simpleCardContext === null || simpleCardContext === void 0 ? void 0 : simpleCardContext.imagePosition) === undefined || simpleCardContext.imagePosition === 'bottom' ? 'top' : simpleCardContext.imagePosition;
  usePropDeprecation({
    name: 'SimpleBlock.fit',
    value: rest.fit,
    version: 'v5.0.0',
    alternative: 'SimpleBlock.contentHeight'
  });
  contentHeight ??= rest.fit ?? 'hug';
  return /*#__PURE__*/React.createElement(InternalProvider, null, /*#__PURE__*/React.createElement(SimpleBlockContext.Provider, {
    value: {
      size,
      contentHeight,
      alignment
    }
  }, /*#__PURE__*/React.createElement(Container, _extends({
    ref: fRef,
    $imagePosition: imagePosition,
    $alignment: alignment
  }, rest), blockImage, /*#__PURE__*/React.createElement(BodyContainer, {
    $imagePosition: imagePosition,
    $size: size,
    $alignment: alignment
  }, children))));
}), {
  ...SimpleBlockComponents
});